import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackSaveWhenNotSignedIn = (listingId: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'signin to save',
        eventLabel: 'save listing',
        eventValue: listingId
    });
};

export const trackSaveListing = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'save',
        eventLabel: 'save listing'
    });
};

export const trackRemoveSavedListing = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'remove',
        eventLabel: 'save listing'
    });
};

export const trackOpenSharing = (listingId: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click to share',
        eventLabel: 'share button',
        eventValue: listingId
    });
};
